//@ts-nocheck directive
import React, { ChangeEvent, useCallback, useState } from "react";
import { UpdateProjectExperimentType } from "../Types/projectExperiment";

import styles from "../Experiments/Experiment.module.css";

import "../lib/RequireUser/index.css";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, set } from "firebase/database";
import { auth, app } from "../lib/firebase";
import {
  deleteDoc,
  doc,
  getFirestore,
  updateDoc,
  collection,
  setDoc,
  deleteField,
} from "firebase/firestore";
import WelcomePage from "../WelcomePage/WelcomePage";
import { profile } from "console";

const tempUser = localStorage.getItem("userUID");
//const prjTitle = localStorage.getItem("projectTitle");
//localStorage.setItem("firstTime", "Yes");
const numberOfExperiments = localStorage.getItem("expNum");
let experimentsCounter = 0;

interface IProps {
  projectExperiment: NewProjectExperimentType;
}

//*new
const uploadUrl =
  "https://us-central1-footprints-b291f.cloudfunctions.net/uploadFile";

const deleteFile =
  "https://us-central1-footprints-b291f.cloudfunctions.net/deleteFile";

const db = getFirestore();

var aimFrom = "";
var collaboratorFrom = "";
var commentsAndAnalysisFrom = "";
var experimentDateFrom = "";
var experimentProfileFrom: NewProjectExperimentType;
var experimentTitleFrom = "";
var experimentUserIDFrom = "";
var methodologyFrom = "";
var nextStepsFrom = "";
var pdfFileURLFrom = "";
var projectTitleFrom = "";
var projectExperimentFrom = "";
var protocolNameDateVersionFrom = "";
var projectUserIDFrom = "";
var resultsFrom = "";
var selectedFrom = "";
var signatureRequestedFrom = "";
var signedFrom = "";

var bodyStyles = document.body.style;
var destFileName = "";

var fromProfile: NewProjectExperimentType = null;
var toProfile: NewProjectExperimentType = null;
var excessProfile: NewProjectExperimentType = null;

function DateToYYYYMMDD(date: Date) {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let monthString = month.toString();
  if (month < 10) {
    monthString = "0" + monthString;
  }
  let day = date.getDate();
  let dayString = day.toString();
  if (day < 10) {
    dayString = "0" + dayString;
  }
  let dateString = `${year}/` + monthString + "/" + dayString;
  return dateString;
}
//*Replace any character that is not a letter, number, or underscore with '_' - new
const sanitizeFileName = (fileName: string): string => {
  console.log(" file name before = ", fileName);
  const tempFile = fileName.replace(/[^a-zA-Z0-9]/g, "_");
  console.log("file name after = ", tempFile);
  return fileName.replace(/[^a-zA-Z0-9]/g, "_");
};

async function getDownloadLink(filename) {
  try {
    // Sanitize the filename before using it
    const sanitizedFileName = sanitizeFileName(filename);

    // Define the URL of the existing Google Cloud Function
    const functionUrl =
      "https://us-central1-footprints-b291f.cloudfunctions.net/generateDownloadLink";

    // Call the cloud function with the sanitized filename
    const response = await fetch(functionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        filename: sanitizedFileName,
      }),
    });

    // Check if the response is successful
    if (response.ok) {
      const data = await response.json();
      return data.downloadLink;
    } else {
      throw new Error("Failed to generate download link");
    }
  } catch (error) {
    console.error("Error getting download link:", error.message);
    throw error;
  }
}
function SharedDataInformation({ projectExperiment }: IProps) {
  const docID = projectExperiment;
  console.log("projectExperiment id = ", docID);
  const tempUID: string = localStorage.getItem("userUID")!;
  const userProfileName: any = localStorage.getItem("userProfileName");

  const [selectedFile, setSelectedFile] = useState<File | null>(null); // Add state for the selected file

  const [copyColor, setCopyColor] = useState("black");
  const [aim, setAIM] = useState("");
  const [collaborator, setCollaborator] = useState("");
  const [commentsAndAnalysis, setCommentsAndAnalysis] = useState("");
  const [copyButton, setCopyButton] = useState("Copy");
  const [copySelected, setCopySelected] = useState(false);
  const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);
  const [requestButtonDisabled, setRequestButtonDisabled] = useState(
    projectExperiment.requestButtonDisabled
  );

  const [experimentDataDescription, setExperimentDataDescription] = useState(
    []
  );
  const [experimentDataDescriptionInput, setExperimentDataDescriptionInput] =
    useState("");

  const [experimentDataShareable, setExperimentDataShareable] = useState([]);
  const [experimentDataShareableInput, setExperimentDataShareableInput] =
    useState("");

  const [experimentDataFileName, setExperimentDataFileName] = useState([]);

  const [dataFileSelectIndex, setDataFileSelectIndex] = useState(0);

  var selectedShareableValue = "";

  const [deleteButton, setDeleteButton] = useState("Delete");
  const [experimentTitle, setExperimentTitle] = useState("");
  const [messages, setMessages] = useState(
    "Select a data file to download then press the Download button and you will select a directory to download to"
  );
  const [methodology, setMethodology] = useState("");
  const [nextSteps, setNextSteps] = useState("");
  const [saveButton, setSaveButton] = useState("");
  const [pdfFileURL, setpdfFileURL] = useState("");
  const [pasteButton, setPasteButton] = useState("Paste");
  const [pdfButton, setPDFButton] = useState("");
  const [experimentDate, setExperimentDate] = useState("");
  const [projectTitle, setProjectTitle] = useState("");
  const [projectUseID, setProjectUseID] = useState(
    projectExperiment.experimentUserID
  );
  const [requestSignature, setRequestSignature] = useState(
    projectExperiment.requestSignature
  );
  const [projectExperimentSigned, setProjectExperimentSigned] = useState("");
  const [protocolNameDateVersion, setProtocolNameDateVersion] = useState("");
  const [results, setResults] = useState("");
  const [selectButton, setSelectButton] = useState("Select");
  const [signatureRequested, setSignatureRequested] = useState("");
  const [signed, setSigned] = useState("");
  const docRef = doc(db, "projectExperiments", projectExperiment.id);
  const [selected, setSelected] = useState("no");
  const [downloadLink, setDonwloadLink] = useState("");
  const [selectedFileName, setSelectedFileName] = useState("");
  var fromToError = 0;

  function handleRequestClick() {
    // Call cloud run function passing the doc.id of this firestore database document:
    // createPDF(projectExperiment.id)
    console.log("in handleRequestClick...");
    // Disable button
    setRequestButtonDisabled(true);
    // Set request button text to "Requested"
    setRequestSignature("Requested");
    // Update the document signatureRequested field
    updateDoc(docRef, {
      signatureRequested: "yes",
    });
  }

  //*Function to upload a data file
  async function uploadDataFile(file: File) {
    console.log("in uploadDataFile...");
    // Sanitize the file name
    const sanitizedFileName = sanitizeFileName(file.name);
    console.log("sanitizedFileName = ", sanitizedFileName);
    // Create a new File object with the sanitized file name
    const sanitizedFile = new File([file], sanitizedFileName, {
      type: file.type,
    });
    console.log("sanitizedFile = ", sanitizedFile);
    const formData = new FormData();
    formData.append("myfile", sanitizedFile);
    console.log("formData = ", formData);
    try {
      const response = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.statusText}`);
      }

      const result = await response.text(); // Assuming the server returns plain text
      console.log("Upload successful:", result);

      console.log("file name:", file.name);
    } catch (error) {
      console.error("Upload error:", error);
    }

    //Now reset dataDescriptionInput, dataShareableInput, and fileSelected to ""
    setMessages("The file has been dowloaded to the selected directory...");
  }

  //*Handle file input change event - new
  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    console.log("in handleFileChange and file = ", file);
    if (file) {
      console.log("Selected file:", file);
      console.log("Selected file name = ", file.name);
      setSelectedFile(file); // Store the selected file in state
      setMessages("File selected...");

      changeSaveButtonTest();
    }
  }

  //*Handle the upload button click - new
  function handleDownloadClick() {
    console.log("in handleDownloadClick");

    console.log("dataDescription input = ", experimentDataDescriptionInput);
    console.log("selectedFile.name = ", selectedFile.name);
    console.log("dataShareable input = ", experimentDataShareableInput);

    let tempArray = experimentDataDescription;
    tempArray.push(experimentDataDescriptionInput);
    setExperimentDataDescription(tempArray);
    tempArray = experimentDataShareable;
    tempArray.push(experimentDataShareableInput);
    setExperimentDataShareable(tempArray);
    tempArray = experimentDataFileName;
    console.log("tempArray = ", tempArray);
    tempArray.push(selectedFile.name);
    setExperimentDataFileName(tempArray);

    let myMap = new Map<string, string>([]);
    let myArray = [];
    let myObject = Object.fromEntries(myMap);
    for (let i = 0; i < experimentDataDescription.length; i++) {
      myMap = new Map<string, string>([
        ["dataDescription", experimentDataDescription[i]],
        ["dataFileName", experimentDataFileName[i]],
        ["dataShareable", experimentDataShareable[i]],
      ]);
      console.log("map = ", myMap);

      myObject = Object.fromEntries(myMap);
      console.log(" myObject = ", myObject);

      myArray.push(myObject);
      console.log("myArray = ", myArray);
    }

    updateDoc(docRef, {
      experimentData: myArray,
    });

    uploadDataFile(selectedFile);
    setUploadButtonDisabled(true);
  }

  function reloadFromError() {
    window.location.reload();
  }

  function messagesFunction(projectExperiments: NewProjectExperimentType) {}

  const URLSelected = async (e: ChangeEvent<HTMLSelectElement>) => {
    //  const [dataFileSelectIndex, setDataFileSelectIndex] = useState(0);
    console.log("in URLSelected...");
    console.log("value from selected event = ", e.currentTarget.selectedIndex);
    setDonwloadLink("");
    const tempIndex = e.currentTarget.selectedIndex;
    setDataFileSelectIndex(tempIndex - 1);
    console.log("index = ", tempIndex);
    console.log("index as set = ", dataFileSelectIndex);
    console.log(" experimentDataDescription = ", experimentDataDescription);
    console.log(
      " experimentDataDescription at index = ",
      experimentDataDescription[tempIndex - 1]
    );
    setExperimentDataDescriptionInput(experimentDataDescription[tempIndex - 1]);
    setExperimentDataShareableInput(experimentDataShareable[tempIndex - 1]);

    // Added code to get the download link
    const tempFileName = experimentDataFileName[tempIndex - 1];
    console.log("tempFileName = ", tempFileName);
    const tempDownLoadLink = await getDownloadLink(tempFileName);
    console.log("tempDownLoadLink = ", tempDownLoadLink);
    setDonwloadLink(tempDownLoadLink);
    setSelectedFileName(tempFileName);
    //experimentDataShareableInput = experimentDataShareable[tempIndex - 1];
    console.log(" experimentDataDescription = ", experimentDataDescription);
    console.log(" experimentDataFileName = ", experimentDataFileName);

    console.log(" experimentDataShareable = ", experimentDataShareable);

    console.log("before selectedShareableValue = ", selectedShareableValue);
    console.log(
      "before experimentDataShareable[tempIndex - 1] = ",
      experimentDataShareable
    );
    //selectedShareableValue = "No";
    console.log("after selectedShareableValue = ", selectedShareableValue);
  };

  function getSelect(e: ChangeEvent<HTMLSelectElement>) {
    console.log("selectedValue = ", e);
    //const temp = e.currentTarget.selectedIndex;
    let temp = e;
    let tempValue = "No";
    if (temp === "Yes") {
      tempValue = "Yes";
    } else if (temp === "WithConsent") {
      tempValue = "With Consent";
    }

    //experimentDataShareable[tempIndex - 1] = tempValue;
    //experimentDataShareableInput = tempValue;
    //setExperimentDataShareableInput(tempValue);
    //experimentDataShareableInput = tempValue;
    setExperimentDataShareableInput(tempValue);
    //window.location.reload();
    console.log("temp value for shareable = ", tempValue);
    console.log(
      "experimentDataShareableInput = ",
      experimentDataShareableInput
    );
    //changeSaveButtonTest();
    //experimentDataDescription.pop();
    //experimentDataFileName.pop();
    //experimentDataShareable.pop();
    //setDataShare(selectObject);
    //console.log("selected value = ", dataShare);
  }

  //projectExperiment is an object from IProps and not an array and
  //therefore the following code is only being acted on once per
  //experiment that comes into the code...this is not an array
  console.log("projectExperiment id = ", projectExperiment.id);
  console.log("firstTime = ", localStorage.getItem("firstTime"));
  if (localStorage.getItem("firstTime") === "Yes") {
    if (projectExperiment.experimentData !== undefined) {
      for (let j = 0; j < projectExperiment.experimentData.length; j++) {
        console.log("projectExperiment id = ", projectExperiment.id);
        for (const [key, value] of Object.entries(
          projectExperiment.experimentData[j]
        )) {
          if (key === "dataDescription") {
            console.log("dataDescription = ", value);
            experimentDataDescription.push(value as string);
          } else if (key === "dataFileName") {
            experimentDataFileName.push(value as string);
          } else if (key === "dataShareable") {
            experimentDataShareable.push(value as string);
          }
        }
      }
    } else {
      //Call function to rewrite/update old experiment format documents
      UpdateOldExperimentFormats(projectExperiment.id);
    }

    localStorage.setItem("firstTime", "No");
  }

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <h1 className={styles.header}>Shared Data from Experiments</h1>
          <button className={styles.closeButton} onClick={() => history.back()}>
            Return
          </button>
        </div>
        <div className={styles.initialSpacing}>
          <label>Instructions&emsp;</label>
          <input
            className={styles.messageText}
            type="text"
            readOnly
            value={messages}
            style={{ paddingLeft: 3, height: 20, marginLeft: 33, width: 710 }}
          />
        </div>
        <div className={styles.initialSpacing}>
          <label>Project Title&emsp;</label>
          <input
            style={{ paddingLeft: 3, height: 20, marginLeft: 30, width: 710 }}
            type="text"
            required
            defaultValue={projectExperiment.projectTitle}
            onChange={(e) => {
              setProjectTitle(e.target.value);
              changeSaveButtonOn();
            }}
          />
        </div>
        <div>
          <label className={styles.userLabel}>Experiment Title&emsp;</label>
          <input
            style={{
              paddingLeft: 3,
              height: 20,
              marginLeft: 15,
              marginRight: 0,
            }}
            type="text"
            size={50}
            inputMode="none"
            defaultValue={projectExperiment.experimentTitle}
          />
          <label>&emsp;&emsp;&emsp;Date</label>
          <input
            style={{ paddingLeft: 3, marginLeft: 115, width: 107 }}
            className={styles.userLabel}
            type="text"
            readOnly
            inputMode="none"
            defaultValue={projectExperiment.experimentDate}
          />
        </div>
        <div className={styles.userLabel}>
          <label>Experimenter</label>
          <input
            style={{ paddingLeft: 3, marginLeft: 50, marginRight: -50 }}
            size={20}
            className={styles.userLabel}
            type="text"
            readOnly
            inputMode="none"
            defaultValue={userProfileName}
          />
          <label style={{ paddingLeft: 297 }}>Collaborator&emsp;</label>
          <input
            style={{ paddingLeft: 3, height: 20, marginLeft: 47, width: 107 }}
            type="text"
            size={21}
            readOnly
            defaultValue={projectExperiment.collaborator}
          />
        </div>

        <div className={styles.aimLabel}>
          <label>Aim/Goal&emsp;</label>
          <textarea
            style={{ paddingLeft: 3, marginLeft: 60, width: 677 }}
            rows={4}
            cols={50}
            defaultValue={projectExperiment.aim}
            readOnly
          />
        </div>
        <div className={styles.aimLabel}>
          <label>Methodology&emsp;</label>
          <textarea
            style={{ paddingLeft: 3, marginLeft: 33, width: 677 }}
            rows={7}
            cols={70}
            defaultValue={projectExperiment.methodology}
            readOnly
          />
        </div>
        <div className={styles.aimLabel}>
          <label>Protocol&emsp;</label>
          <textarea
            style={{ paddingLeft: 3, height: 20, marginLeft: 66, width: 677 }}
            rows={1}
            cols={70}
            defaultValue={projectExperiment.protocolNameDateVersion}
            readOnly
          />
        </div>
        <div className={styles.aimLabel}>
          <label>Results&emsp;</label>
          <textarea
            style={{ paddingLeft: 3, marginLeft: 71, width: 677 }}
            rows={4}
            cols={70}
            defaultValue={projectExperiment.results}
            readOnly
          />
        </div>
        <div className={styles.aimLabel}>
          <label>Comments&emsp;</label>
          <textarea
            style={{ paddingLeft: 3, marginLeft: 46, width: 677 }}
            rows={4}
            cols={50}
            defaultValue={projectExperiment.commentsAndAnalysis}
            readOnly
          />
        </div>
        <div className={styles.aimLabel}>
          <label>Next Steps&emsp;</label>
          <textarea
            style={{ paddingLeft: 3, marginLeft: 46, width: 597 }}
            rows={3}
            cols={50}
            defaultValue={projectExperiment.nextSteps}
            readOnly
          />
        </div>

        <div className={styles.descriptionLabel}>
          <label style={{ marginLeft: 19 }}>Data File&emsp;</label>
          {/* experimentDataFileName and this needs to be a listbox */}
          <select
            name="Data URL"
            id="URL-select"
            size={experimentDataFileName.length + 1}
            style={{ marginLeft: 61, padding: 3 }}
            onChange={URLSelected}
          >
            <option value="">-- Data File Selection --</option>
            {experimentDataFileName.map((experimentDataFileName, key) => (
              <option key={key} value={experimentDataFileName}>
                {experimentDataFileName}
              </option>
            ))}
          </select>
          <label>&emsp;Data Description&emsp;</label>
          <textarea
            style={{ paddingLeft: 3, height: 22 }}
            rows={1}
            cols={50}
            //defaultValue={projectExperiment.experimentDataDescriptionInput}
            value={experimentDataDescriptionInput}
            onChange={(e) => {
              setExperimentDataDescriptionInput(e.target.value);
              changeSaveButtonTest();
            }}
          />
          <label>&emsp;Shareable&emsp;</label>
          <textarea
            name="select-shareable-input"
            id="select-shareable-input"
            style={{ paddingLeft: 3, height: 22 }}
            rows={1}
            cols={13}
            readOnly
            value={experimentDataShareableInput}
          />
        </div>
        <div>
          {downloadLink ? (
            <FileDownloader
              fileUrl={downloadLink}
              fileName={selectedFileName}
              onSuccess={() => {
                console.log("Downloaded successfully");
              }}
              onError={() => {
                console.log("Download failed");
              }}
            />
          ) : (
            <p style={{ paddingLeft: 160 }}>Select File to Download</p>
          )}
        </div>
      </div>
      <br></br>
    </>
  );
}

export const FileDownloader = ({ fileUrl, fileName, onSuccess, onError }) => {
  const [status, setStatus] = useState("idle"); // 'idle', 'downloading', 'success', 'error'
  const [progress, setProgress] = useState(0); // Progress percentage

  const downloadFile = async () => {
    try {
      if ("showSaveFilePicker" in window) {
        const options = {
          suggestedName: fileName,
        };

        const fileHandle = await (window as any).showSaveFilePicker(options);
        const writable = await fileHandle.createWritable();
        setStatus("downloading");
        setProgress(0);

        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const contentLength = response.headers.get("content-length");
        if (!contentLength) throw new Error("Content-Length header is missing");

        const total = parseInt(contentLength, 10);
        let loaded = 0;

        const reader = response.body.getReader();
        const chunks = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          loaded += value.length;
          setProgress(Math.round((loaded / total) * 100));
        }

        const blob = new Blob(chunks);
        await writable.write(blob);
        await writable.close();
      } else {
        const link = document.createElement("a");
        setStatus("downloading");
        setProgress(0);

        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const contentLength = response.headers.get("content-length");
        if (!contentLength) throw new Error("Content-Length header is missing");

        const total = parseInt(contentLength, 10);
        let loaded = 0;

        const reader = response.body.getReader();
        const chunks = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          loaded += value.length;
          setProgress(Math.round((loaded / total) * 100));
        }

        const blob = new Blob(chunks);
        const blobUrl = window.URL.createObjectURL(blob);
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }

      setStatus("success");
      setTimeout(() => {
        setStatus("idle");
        setProgress(0);
      }, 3000);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Download failed:", error);
      setStatus("error");
      setTimeout(() => {
        setStatus("idle");
        setProgress(0);
      }, 3000);
      if (onError) onError(error);
    }
  };

  return (
    <div className={styles.input_container}>
      <button
        className={styles.dataSubmitButton}
        //disabled={uploadButtonDisabled}
        onClick={downloadFile}
        style={{ marginTop: 7, marginLeft: 159 }}
        type="button"
      >
        Download
      </button>
      {status === "downloading" && <p>Downloading... {progress}%</p>}
      {status === "success" && <p>Download successful!</p>}
      {status === "error" && <p>Download failed.</p>}
    </div>
  );
};
export default SharedDataInformation;
